<template>
    <div>
        <div v-if="value == 0 && data.column.field != 'visits'" style="margin: 5px">
            <img src="@/assets/img/tenor.gif"/>
        </div>
        <div v-else-if="data.column.field == 'visits'" class="pl-4 pt-2 pd-2 pr-4">
            <p >{{$t('Visits')}}: {{obj}}</p>
        </div>
        <div v-else-if="isDayTimeline" class="day-timeline-layout">
            <alarm-day-timeline
                v-if="timelineAlarms != null"
                :alarms="timelineAlarms"
                :day="day"
                :selected-id="selectedAlarmId"
                @visible-change="onTimelineVisibleChange"
                @select="selectAlarmInGrid"
            ></alarm-day-timeline>
            <div class="day-timeline-grid">
                <ejs-grid ref="system_modal_grid" height="100%" width="100%" :selectionSettings="selectionOptions" :allowTextWrap="true" :textWrapSettings="wrapSettings" :dataBound="dataBound" :rowSelected="rowSelected" :dataSource="visibleAlarms" :allowPaging="true" :pageSettings="pageSettings" :allowFiltering="true" :filterSettings="filterOptions" :allowSorting="true" :allowMultiSorting='true' :allowPdfExport='true' :allowCsvExport='true' :allowExcelExport='true' :showBusyIndicator="true" style="position: relative">
                    <e-columns>
                        <e-column field="number" :headerText="$t('Unit')" textAlign="Left" :customAttributes="customAttributes"></e-column>
                        <e-column field="type" :headerText="$t('Type')" textAlign="Left" :customAttributes="customAttributes"></e-column>
                        <e-column field="alarmType" :headerText="$t('AlarmType')" textAlign="Left" :customAttributes="customAttributes"></e-column>
                        <e-column field="createDate" :headerText="$t('CreateDate')" textAlign="Left" :customAttributes="customAttributes" :filter="filterMenu" type="datetime" :format="dateTimeFormatOptions"></e-column>
                        <e-column field="endDate" :headerText="$t('EndDate')" textAlign="Left" :customAttributes="customAttributes" :filter="filterMenu" type="datetime" :format="dateTimeFormatOptions"></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
        </div>
        <div v-else style="width: 85vw; height: 80vh">
            <sci-chart-one-line-alarms style="margin-left: 2.5vw;" :dataset="obj" :initialZoomOut="true" :sid="1" :day="day" :name="data.column.field"></sci-chart-one-line-alarms>
            <div class="height-120" style="display: flex; flex-direction: column; flex: 1;">
                <ejs-grid ref="system_modal_grid" height="100%" width="100%" :selectionSettings="selectionOptions" :allowTextWrap="true" :textWrapSettings="wrapSettings" :dataBound="dataBound" :dataSource="obj" :allowPaging="true" :pageSettings="pageSettings" :allowFiltering="true" :filterSettings="filterOptions" :allowSorting="true" :allowMultiSorting='true' :allowPdfExport='true' :allowCsvExport='true' :allowExcelExport='true' :showBusyIndicator="true" style="position: relative">
                    <e-columns>
                        <e-column field="number" :headerText="$t('Unit')" textAlign="Left" :customAttributes="customAttributes"></e-column>
                        <e-column field="type" :headerText="$t('Type')" textAlign="Left" :customAttributes="customAttributes"></e-column>
                        <e-column field="alarmType" :headerText="$t('AlarmType')" textAlign="Left" :customAttributes="customAttributes"></e-column>
                        <e-column field="createDate" :headerText="$t('CreateDate')" textAlign="Left" :customAttributes="customAttributes" :filter="filterMenu" type="datetime" :format="dateTimeFormatOptions"></e-column>
                        <e-column field="endDate" :headerText="$t('EndDate')" textAlign="Left" :customAttributes="customAttributes" :filter="filterMenu" type="datetime" :format="dateTimeFormatOptions"></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
        </div>
    </div>

</template>

<script>
import { getSystemAlarmFromDay, getAlarmsByIdAndDay, getDeviceAlarmFromDay,getAlarmsForDetailsModal } from '@/api/api'
import { GridPlugin, Sort, Page, Filter, Toolbar, Search, CommandColumn, PdfExport, ExcelExport } from "@syncfusion/ej2-vue-grids";
import Modal from '../Modal.vue';
import SciChart from '../SciChart.vue';
import SciChartMultiple from '../SciChartMultiple.vue';
import SciChartOneLineAlarms from '../Charts/SciChartOneLineAlarms.vue'
import AlarmDayTimeline from '../Charts/AlarmDayTimeline.vue'

export default {
    components: {
        Modal,
        SciChart,
        SciChartMultiple,
        SciChartOneLineAlarms,
        AlarmDayTimeline
    },
    provide:{ 
        grid: [ Sort, Page, Filter, Toolbar, Search, CommandColumn, PdfExport, ExcelExport],
    },
    props: {
        data: {
            type: Object,
            required: true
        },
        day: {
            type: Number,
            required: false,
            default: 0
        },
        apiMethodName: {
            type: String,
            required: true
        },
        value: {
            type: Number
        }
    },
    data() {
        return {
            obj: [],
            // Oś czasu alarmów dnia (kafelki High/Mid/Low w liście systemów).
            timelineAlarms: null,
            visibleAlarms: [],
            selectedAlarmId: null,
            pendingGridSelection: null,
            filterMenu: {
                type: "Menu"
            },
            pageSettings: { pageSize: 100, pageSizes: [10, 25, 50, 100] },
            wrapSettings: { wrapMode: "Content" },
            selectionOptions: { type: "Multiple" },
            filterOptions: {
              type: "CheckBox",
            },
            dateTimeFormatOptions: { format: 'yyyy-MM-dd HH:mm:ss', type:'dateTime'},
            customAttributes: { class: "customcss" },
        }
    },
    methods: {
        async getData() {           
            var field = this.data.column.field

            switch(this.apiMethodName){
                case 'getSystemAlarmFromToday':
                    this.obj = await getSystemAlarmFromDay(this.data.id, field.charAt(field.length - 1), this.day)
                    break;
                case 'getAlarmsByIdAndDay':
                    this.obj = await getAlarmsByIdAndDay(this.data.id, this.day)
                    break;
                case 'getAlarmsForDetailsModal':
                    this.obj = await getAlarmsForDetailsModal(this.data.alarmTypeId, this.data.systemId, this.data.deviceId, this.day)
                    break;
                case 'getDeviceAlarmFromDay':
                    this.obj = await getDeviceAlarmFromDay(this.data.id, field, this.day)
                    break;
                case 'getVisitsForDay':
                    this.obj = this.data[this.data.column.field][this.day];
                    break;
            }

            for(let i = 0; i < this.obj.length; i++){
                this.obj[i]['createDate'] = new Date(this.obj[i]['createDate'].toDateTime())  
                // 0001-01-01 (brak końca) JS czyta jako rok 2001, więc tabela pokazywała 2001-01-01.
                this.obj[i]['endDate'] = this.obj[i]['endDate'].indexOf('0001-01-01') === 0
                    ? null
                    : new Date(this.obj[i]['endDate'].toDateTime())
                this.obj[i]['alarmType'] = this.$t(this.obj[i]['alarmType'])
            }

            // Oś czasu dostaje listę dopiero po zamianie dat i tłumaczeniu typów.
            if (this.isDayTimeline) {
                this.timelineAlarms = this.apiMethodName == 'getAlarmsForDetailsModal'
                    // Tu wszystkie alarmy są jednego typu, a pole alarmType niesie opis
                    // konkretnego alarmu: legenda dostaje nazwę typu, opis idzie do dymka.
                    ? this.obj.map(a => ({ ...a, alarmType: this.data.alarmType, alarmTypeId: this.data.alarmTypeId, description: a.alarmType }))
                    : this.obj.slice()
            }
        },
        dataBound: function () {
			const grid = this.$refs.system_modal_grid
			grid.autoFitColumns();

			if (this.pendingGridSelection != null) {
				const pageIndex = grid.getCurrentViewRecords().findIndex(r => r.id == this.pendingGridSelection)
				this.pendingGridSelection = null
				if (pageIndex !== -1) grid.selectRow(pageIndex)
			}
		},
        // Oś czasu może pracować na kopiach wierszy, więc tabela bierze oryginały po id.
        onTimelineVisibleChange(list) {
            const ids = {}
            list.forEach(a => { ids[a.id] = true })
            this.visibleAlarms = this.obj.filter(a => ids[a.id])
        },
        rowSelected(args) {
            if (!this.isDayTimeline || args.data == null || Array.isArray(args.data)) return
            this.selectedAlarmId = args.data.id
        },
        // Klik w pasek na osi czasu zaznacza wiersz w tabeli, w razie potrzeby na innej stronie.
        selectAlarmInGrid(id) {
            this.selectedAlarmId = id
            const grid = this.$refs.system_modal_grid
            if (grid == null) return

            const pageIndex = grid.getCurrentViewRecords().findIndex(r => r.id == id)
            if (pageIndex !== -1) {
                grid.selectRow(pageIndex)
                return
            }

            const index = this.visibleAlarms.findIndex(a => a.id == id)
            if (index === -1) return
            this.pendingGridSelection = id
            grid.goToPage(Math.floor(index / grid.ej2Instances.pageSettings.pageSize) + 1)
        },
    },
    computed: {
        isDayTimeline() {
            return this.apiMethodName == 'getSystemAlarmFromToday' || this.apiMethodName == 'getAlarmsForDetailsModal'
        }
    },
    mounted: async function() {
        this.getData()
    }
}
</script>


<style scoped>
.height-120 {
    height: calc(80vh - 120px);
}

.day-timeline-layout {
    display: flex;
    flex-direction: column;
    width: 85vw;
    height: 80vh;
}

.day-timeline-grid {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 220px;
}
</style>



// WEBPACK FOOTER //
// src/components/Systems/SystemAlarmsDetailsModal.vue